
import React from 'react';
import { Skeleton } from "@/components/ui/skeleton";
import { useNavigate } from 'react-router-dom';
import { Tag } from 'lucide-react';

interface TrendingTopicsProps {
  topics: string[];
  loading?: boolean;
  onTopicClick?: (topic: string) => void;
}

const TrendingTopics: React.FC<TrendingTopicsProps> = ({
  topics,
  loading = false,
  onTopicClick
}) => {
  const navigate = useNavigate();
  
  const handleTopicClick = (topic: string) => {
    if (onTopicClick) {
      onTopicClick(topic);
    } else {
      navigate(`/tags/${encodeURIComponent(topic)}`);
    }
  };

  if (loading) {
    return <section className="mb-8">
        <Skeleton className="h-6 w-32 mb-4" />
        <div className="flex flex-wrap gap-2">
          {Array(8).fill(0).map((_, i) => <Skeleton key={i} className="h-8 w-24 rounded-full" />)}
        </div>
      </section>;
  }
  
  if (topics.length === 0) {
    return <section className="mb-8">
        <h2 className="font-medium text-lg mb-4 flex items-center">
          <Tag className="h-4 w-4 mr-2" />
          Trending Topics
        </h2>
        <p className="text-muted-foreground text-sm">No trending topics available at the moment.</p>
      </section>;
  }
  
  return (
    <section className="mb-8">
      <h2 className="font-medium text-lg mb-4 flex items-center">
        <Tag className="h-4 w-4 mr-2" />
        Trending Topics
      </h2>
      <div className="flex flex-wrap gap-2">
        {topics.map((topic, index) => (
          <button
            key={index}
            onClick={() => handleTopicClick(topic)}
            className="px-3 py-1.5 rounded-full bg-primary/10 hover:bg-primary/20 text-sm font-medium transition-colors"
          >
            {topic}
          </button>
        ))}
      </div>
    </section>
  );
};

export default TrendingTopics;
